import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SpecialsService } from '@core';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { LoadingComponent } from '@app/components/loading/loading.component';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { SwiperVideoControlDirective } from '@core/lib/components/swiper/swiper-video-control.directive';

@Component({
  selector: 'app-page-promos',
  templateUrl: './promos.component.html',
  styleUrl: './promos.component.scss',
  imports: [
    LoadingComponent,
    SwiperContainerComponent,
    PageHeaderComponent,
    SwiperSlideComponent,
    SwiperVideoControlDirective,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromosComponent {
  private readonly specialsService = inject(SpecialsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  private readonly specials$ = this.specialsService.specials$;

  public readonly specials = toSignal(this.specials$);

  public readonly loading = toSignal(this.specialsService.loading$, {
    initialValue: true,
  });

}
